import React from "react";
import classnames from "classnames";
import style from "./StrokedEmoteImage.module.scss";

interface StrokedEmoteImageProps {
  src: string;
  className?: string;
}

const StrokedEmoteImage: React.FC<StrokedEmoteImageProps> = ({ src, className }) => {
  return (
    <div className={classnames(style.strokedEmoteImage, className)}>
      <img className={style.strokedEmoteImage__stroke} src={src} />
      <img className={style.strokedEmoteImage__img} src={src} />
    </div>
  );
};

export default StrokedEmoteImage;
